export default __webpack_public_path__ + "static/media/scooter.cf9bb57e.svg";